var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "08E52D63-1974-4E77-8235-9223F21E2337") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.-Who-can-use-Hana-UI",
    transform: "translate(-881.000000, -511.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(882.000000, 512.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.01984,15.60463 C18.01984,15.60463 24.32404,18.43753 25.84024,19.11583 C27.35644,19.79423 27.95494,21.23053 27.27664,22.42753 C26.59834,23.62453 24.16444,22.42753 24.16444,22.42753 L14.26924,17.71933 L15.78544,5.74013",
    id: "Stroke-1",
    stroke: "#EE7330",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.60837,10.25805 L24.40387,14.44765 C24.40387,14.44765 31.42627,16.88145 31.50607,22.18815 C31.58587,27.49485 27.55407,29.68935 27.55407,29.68935 L28.71307,33.91875 L14.26927,33.91875 L15.65537,21.37295",
    id: "Stroke-3",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.70065,
    y1: 38.54711,
    x2: 17.02235,
    y2: 33.91881,
    id: "Stroke-5",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.88825,
    y1: 38.54711,
    x2: 24.24425,
    y2: 33.91881,
    id: "Stroke-7",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.69094,22.34545 C44.69094,34.68645 34.68654,44.69085 22.34544,44.69085 C10.00444,44.69085 4e-05,34.68645 4e-05,22.34545 C4e-05,10.00435 10.00444,-5e-05 22.34544,-5e-05 C34.68654,-5e-05 44.69094,10.00435 44.69094,22.34545 Z",
    id: "Stroke-9",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.93019,8.0476 C43.93019,12.2633 40.51269,15.6808 36.29689,15.6808 C32.08119,15.6808 28.66369,12.2633 28.66369,8.0476 C28.66369,3.8319 32.08119,0.4143 36.29689,0.4143 C40.51269,0.4143 43.93019,3.8319 43.93019,8.0476",
    id: "Fill-11",
    fill: "#BE1622"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.04274,
    y1: 5.7934,
    x2: 38.55114,
    y2: 10.3018,
    id: "Stroke-13",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.55114,
    y1: 5.7934,
    x2: 34.04274,
    y2: 10.3018,
    id: "Stroke-15",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup17);
export default __webpack_public_path__ + "static/media/Group 17.56c3a659.svg";
export { ForwardRef as ReactComponent };